import React, { useEffect } from "react";
import "./index.css";
import { start } from "./gradient";

interface GradientAnimationProps {
  height?: number;
}

const GradientAnimation: React.FC<
  GradientAnimationProps & React.HTMLAttributes<HTMLDivElement>
> = ({ height }) => {
  useEffect(() => {
    start(height);
  }, []);

  return (
    <div className="gradient-background">
      <canvas id="gradient-canvas"></canvas>
    </div>
  );
};

GradientAnimation.displayName = "GradientAnimation";

GradientAnimation.defaultProps = {
  height: 1200,
};

export default GradientAnimation;
